<div class="input-group" paceCoreValidationMessage [validation]="ratingInputControl">
    <rating
        [formControl]="ratingInputControl"
        [customTemplate]="faRatingTemplate"
        [max]="model.options.maxIcons"
        [attr.aria-label]="ariaLabel"
    >
    </rating>
    <ng-template #faRatingTemplate let-index="index" let-value="value">
        <fa-icon [icon]="index < value ? faStar : farStar" size="2x"></fa-icon>
    </ng-template>
</div>
